<app-base-modal
  [open]="open"
  (openChange)="openChange.emit($event)"
  title="Add Researchers to Project"
  [size]="'lg'"
>
  <div class="space-y-4">
    <!-- Info Message -->
    <div class="text-sm text-gray-600 mb-4">
      Click the "Add" button next to each member to quickly add them as researchers.
      @if (getAvailableCount() > 0) {
        <span class="font-semibold">{{ getAvailableCount() }} members available</span>
      }
    </div>

    <!-- Error Alert -->
    @if (error) {
      <app-base-alert
        type="error"
        title="Error adding researcher"
        [message]="error.detail || error"
        (closed)="error = ''"
      ></app-base-alert>
    }

    <!-- Success Message -->
    @if (successMessage) {
      <div class="px-4 py-3 rounded-lg bg-green-50 border border-green-200 text-green-800 text-sm">
        ✓ {{ successMessage }}
      </div>
    }

    <!-- Members List -->
    <div class="space-y-2 max-h-96 overflow-y-auto">
      @if (availableMembers.length === 0) {
        <div class="text-center py-8 text-gray-500">
          <p>
            No available members to add. All group members are already researchers on this project.
          </p>
        </div>
      } @else {
        @for (member of availableMembers; track member.user.id) {
          <div
            class="flex items-center justify-between p-3 border border-slate-200 rounded-lg hover:bg-slate-50 transition-colors"
            [class.opacity-50]="hasBeenAdded(member.user.id)"
          >
            <div class="flex-1 min-w-0">
              <p class="font-semibold text-gray-900 text-sm">
                {{ getMemberName(member) }}
              </p>
              <p class="text-xs text-gray-600 mt-1">{{ member.user.email }}</p>
            </div>
            <button
              type="button"
              (click)="addResearcher(member)"
              [disabled]="isAddingMember(member.user.id) || hasBeenAdded(member.user.id)"
              class="ml-3 flex-shrink-0"
              [ngClass]="{
                'btn-small-primary': !hasBeenAdded(member.user.id),
                'btn-small-secondary': hasBeenAdded(member.user.id),
              }"
            >
              @if (isAddingMember(member.user.id)) {
                Adding...
              } @else if (hasBeenAdded(member.user.id)) {
                ✓ Added
              } @else {
                Add
              }
            </button>
          </div>
        }
      }
    </div>

    <!-- Modal Footer -->
    <div data-modal-footer class="flex justify-end gap-2 pt-2">
      <button
        type="button"
        class="px-4 py-2 bg-gray-200 hover:bg-gray-300 rounded-md transition-colors font-semibold"
        (click)="close()"
      >
        Done
      </button>
    </div>
  </div>
</app-base-modal>
